import React from "react"

const Navbar = ({ children, className, expand, variant,bg, id=false}) => {
expand = `navbar-expand${expand !==true ? `-${expand}` : ''}`
className = `navbar ${expand}${variant ? ` navbar-${variant}`:''}${bg ? ` bg-${bg}`:''}${className ? ` ${className}`: ''}`
  return <div className={className}  id={id ? `${id}` : null}>{children}</div>
}
export default Navbar
